import { render, staticRenderFns } from "./Snatch.vue?vue&type=template&id=890d6f46&"
import script from "./Snatch.vue?vue&type=script&lang=js&"
export * from "./Snatch.vue?vue&type=script&lang=js&"
import style0 from "./Snatch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports